<template>
<span>
    <div class="flavor-modal-overlay" v-if="selectedCategory" @click="selectedCategory = null">
        <div class="flavor-modal" @click.stop>
            <div class="container">
                <FlavorCard v-for="(flavor, index) in filteredFlavors" :key="flavor.vqid" :flavor="flavor" :column="index % 3"></FlavorCard>
            </div>
        </div>
    </div>
    <div class="categories">
        <div v-for="(n, i) in 4" :key="i" class="touple" >
            <div 
                @click="selectedCategory = flavorCategories[i * 2]"
                class="card" 
                :style="{ backgroundImage : `url('${require('../assets/categories/' + flavorCategories[(i * 2)] + '.jpg')}')` }"
            >
                <h3>{{ flavorCategories[(i * 2)] }}</h3>
            </div>
            <div 
                @click="selectedCategory = flavorCategories[(i * 2) + 1]"
                class="card" 
                :style="{ backgroundImage : `url('${require('../assets/categories/' + flavorCategories[(i * 2) + 1] + '.jpg')}')` }"
            >
                <h3>{{ flavorCategories[(i * 2) + 1] }}</h3>
            </div>
        </div>
    </div>
    <div style="margin-bottom: 60px;"></div>
</span>
</template>

<script>
// @ is an alias to /src
import FlavorCard from '@/components/FlavorCard.vue'

import axios from 'axios'
import _ from 'lodash'
export default {
    name: 'home',
    components: { FlavorCard },
    data() {
        return {
            flavors: [],
			flavorCategories: [],
			selectedCategory: null,
            pageBottom: null,
            showBottomNav: false,
            showOverlay: false
        }
    },
    created: async function() {
        this.flavors = (await axios.get('https://api.thevapequeen.com/flavors').catch(e => console.log(e))).data
		for (let flavor of this.flavors) {
			if (this.flavorCategories.indexOf(flavor.category) === -1) this.flavorCategories.push(flavor.category)
		}
    },
    mounted() {
        window.addEventListener('scroll', this.scrollHandler)
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.scrollHandler)
    },
	computed: {
		filteredFlavors() {
			if (!this.selectedCategory) return this.flavors
			else return this.flavors.filter(x => x.category === this.selectedCategory)
		}
	},
    methods: {
        scrollHandler: _.debounce(function() {
            let distanceFromBottom = (document.body.offsetHeight - window.innerHeight) - window.scrollY
            console.log(distanceFromBottom)
            console.log(document.body.offsetHeight)
            if (distanceFromBottom < 240) this.pageBottom = true
            else this.pageBottom = false
        }, 50)
    }
}
</script>
<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Nunito+Sans');

.flavor-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #000000aa;
    z-index: 3;
    display: flex;
    justify-content: center;
    align-items: center;
	font-family: Nunito Sans;
    .flavor-modal {
        width: 80%;
        height: 90%;
        background: #00000000;
        border-radius: 10px;
        overflow: scroll;
        z-index: 4;
    }
}

.categories {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    .touple {
        width: 100%;
    }
    .card {
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        font-family: Nunito Sans;
        font-size: 2em;
        position: relative;
        height: 100%;
        width: 100%;
        margin-right: 5%;
        margin-left: 5%;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        &:hover {
            cursor: pointer;
        }
    }
}

.cat-icon {
    width: 60px;
    height: 60px;
    border-radius: 100%;
    background-color: white;
    margin-left: 20px;
    margin-right: 20px;
    margin-top: 40px;
    margin-bottom: 40px;
    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.5);
    transition: all 0.2s ease;
}

.cat-icon.selected {
    background-color: pink;
    width: 80px;
    height: 80px;
    margin-bottom: 20px;
    margin-top: 20px;
    transition: all 0.2s ease;
}

.cat-icon:hover {
    box-shadow: 0 8px 16px 0 rgba(0,0,0,0.5);
    width: 80px;
    height: 80px;
    margin-bottom: 20px;
    transition: all 0.2s ease;
    background: grey;
}

.container {
	display: flex;
	flex-wrap: wrap;
    widht: 90%;
	justify-content: center;
    transition: all 1s ease;
}

.container.page-bottom {
    margin-bottom: 10px !important;
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
    transition: all 1s ease;
}

.show-nav {
    background: red;
}

.bottom-nav {
    background: blue;
	display: flex;
    justify-content: center;
    flex-wrap: wrap;
	overflow: hidden; 
	position: fixed; 
	width: 100%;
    bottom: 0;
    align-items: center;
    overflow: visible;
    transition: all 1s ease;
    animation-duration: 1s;
    animation-name: slide_up;
}

.hidden {
    display: none;
}

@keyframes slide_up {
    from { top: 0% }
    to { top: 100% }
}

.bottom-nav.page-bottom {
    position: relative; 
    transition: all 1s ease;
}

@media screen and (max-width: 768px) {
    .categories {
        .touple {
            margin: 0;
            .card {
                margin-left: 0;
                margin-right: 0;
            }
        }
    }
}
</style>
